import Link from 'next/link';
import React, { HTMLAttributeAnchorTarget } from 'react';

import { Box, Collapse, MantineColor, MantineStyleProps, ThemeIcon, UnstyledButton } from '@mantine/core';

import cx from './SidebarNav.Item.module.scss';

export type SidebarNavItemProps = {
    value?: string;
    icon?: React.ReactNode;
    href?: string;
    target?: HTMLAttributeAnchorTarget;
    onClick?: () => void;
    color?: MantineColor;
    children: React.ReactNode;
    rightSection?: React.ReactNode;
    active?: () => boolean;
    hidden?: boolean;
    w?: MantineStyleProps['w'];
};

const SidebarNavItem = ({
    icon,
    href,
    target,
    onClick,
    color,
    children,
    rightSection,
    hidden,
    w,
}: SidebarNavItemProps) => {
    const props: any = {
        'className': cx.item,
        ...(color ? { 'data-color': color } : {}),
        'data-has-icon': !!icon,
    };

    if (href) {
        props.component = Link;
        props.href = href;
        props.target = target;
    } else {
        props.onClick = onClick;
    }

    return (
        <Collapse expanded={!hidden}>
            <UnstyledButton component="a" {...props}>
                <Box className={cx.leftSection}>
                    {icon && (
                        <ThemeIcon size={34} variant="default" radius="md">
                            {icon}
                        </ThemeIcon>
                    )}

                    <Box className={cx.text} w={w}>
                        <span>{children}</span>
                    </Box>
                </Box>

                {rightSection && <Box className={cx.rightSection}>{rightSection}</Box>}
            </UnstyledButton>
        </Collapse>
    );
};

export { SidebarNavItem };
